import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../teamschat-dialog.action';
import { TeamschatDialogState } from '../teamschat-dialog.state';

import { SendMessage } from './send-message.action';

// TODO revise. maybe do this in the result reducer
export function sendMessageReducer(
    state: TeamschatDialogState,
    action: PayloadAction<ActionType, SendMessage>,
): TeamschatDialogState {
    /* TODO find a way to immediately show the message and merge it once it's confirmed */

    // const nextMessages = [...state.messages];
    // nextMessages.push(action.payload.message);

    // const nextConversation = [...state.conversation];
    // nextConversation.push({ ...action.payload.message, isUser: true });

    return {
        ...state,
        // messages: nextMessages,
        // conversation: nextConversation,
    };
}
